/* 🤖 this file was generated by svg-to-ts */
export const mgcIconNavigationFilled: {
  name: 'navigation-filled';
  data: string;
} = {
  name: 'navigation-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M11.4 5.703C5.498 7.828 2.844 8.801 2.716 8.888a1.193 1.193 0 0 0-.161 1.819c.08.077.196.167.258.2.062.032 1.744.696 3.737 1.476s3.629 1.423 3.635 1.428c.006.006.648 1.641 1.428 3.633a322 322 0 0 0 1.478 3.739c.095.183.325.398.536.501.284.139.754.133 1.036-.013.234-.121.468-.364.559-.58.035-.083 1.43-3.947 3.101-8.587 2.877-7.99 3.037-8.449 3.036-8.7a1.132 1.132 0 0 0-.647-1.042.93.93 0 0 0-.528-.121c-.274.001-.581.108-8.784 3.062"/></svg>`
};
